
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in/company",
      function () {
        return require("private-next-pages/sign-in/company.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-in/company"])
      });
    }
  